import NavItems from "./NavItems"
import HeaderLogo from "./components/HeaderLogo";
import "./Header.css"
import ramadanImg from "../../assets/ramadan/DecorationBackground.jpg"
import { isRamadan, isEidAlfitr, isEidAladha, isSaudiNationalDay } from "../occasions"
import Fanous from "../occasions/fanous";
import Decoration from "../occasions/decoration";
import EidAladha from "../occasions/eidAdha";
import { SaudiNationalHeader } from "../occasions/saudiNationalDay";

export default function Header() {

  return (
    <header className={`py-0 bg-light-gray position-relative z-3 bgOpacity10`}>
      <div className="container-md d-flex">
        <HeaderLogo />
        <NavItems />
      </div>
      {isRamadan && <>
        <img src={ramadanImg} alt="ramadan" className="ramadan-img" />
        <Fanous />
      </>}
      {isEidAlfitr &&
        <Decoration />
      }
      {isEidAladha &&
        <EidAladha />
      }
      {isSaudiNationalDay &&
        <SaudiNationalHeader />
      }
    </header>

  );
}
